(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.address-kyc-uk', ['ng.cork.ui.focus-on', 'pp.widgets-templates', 'pp.services.core', 'pp.services.gbGroup', 'pp.components.required-any', 'pp.values.form-lists']);

// @todo general purpose, lift
function ridGenerator(len) {
    var S4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    var str = '';
    while (str.length < len) {
        str += S4();
    }
    return str.substring(0, len);
}

/**
 * @ngdoc directive
 * @name ppAddressUk
 * @description
 * UK Address form with 2-step postcode lookup via Ideal Postcodes:
 * 1. Enter postcode → get address suggestions
 * 2. Select suggestion → resolve full address
 *
 * @restrict A
 * @scope
 * @param {object} address
 * @param {string} country
 * @param {boolean} feedbackEnabled
 * @param {boolean} lookupAvailable
 */
ngModule.directive('ppAddressUk', ['$http', 'gbGroupService', 'ppBrowser', function ($http, gbGroupService, ppBrowser) {
    return {
        restrict: 'A',
        templateUrl: 'widgets/_angular/address-kyc-uk/address-kyc-uk.tpl.html',
        scope: {
            address: '=ppAddressUk',
            country: '@',
            inputDisabled: '=',
            feedbackEnabled: '=',
            lookupAvailable: '@',
            index: '@',
            isProcessing: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: ['$scope', '$element', 'ppTrack', 'ppComponentEmitter', function ($scope, $element, ppTrack, ppComponentEmitter) {
            var vm = this;

            // -- initial state

            vm.rid = ridGenerator(4);

            vm.mobile = ppBrowser.isMobile;
            vm.enterManually = false;
            vm.postcodeRegexp = gbGroupService.postcodeRegexp;
            vm.lookupInProgress = false;
            vm.resolveInProgress = false;
            vm.inlineNotices = {};

            function updateProcessing() {
                vm.isProcessing = vm.lookupInProgress || vm.resolveInProgress;
            }

            // -- util functions

            function clearAddress() {
                for (var prop in vm.address) {
                    delete vm.address[prop];
                }
            }

            // -- api

            // Step 1: find address suggestions for a postcode
            vm.lookupAddress = function () {
                vm.lookeduppostcode = vm.postcode;
                clearAddress();
                if (vm.form.postcode.$invalid) {
                    vm.lookupFeedbackEnabled = true;
                } else {
                    vm.lookupInProgress = true;
                    updateProcessing();
                    vm.lookupError = null;
                    vm.suggestions = null;
                    vm.selectedSuggestion = null;
                    gbGroupService.findAddresses(vm.postcode).then(function (suggestions) {
                        vm.suggestions = suggestions;
                    }, function (error) {
                        vm.suggestions = [];
                        vm.lookupError = error.reason;
                        vm.lookupFeedbackEnabled = true;
                        if (error.reason === 'gbGroup.error.noMatches' || error.reason === 'gbGroup.error.postcode.invalid') {
                            vm.postcodeNotMatched = vm.postcode;
                        }
                    })['finally'](function () {
                        vm.lookupInProgress = false;
                        updateProcessing();
                    });
                }
            };

            // lookup when user presses enter
            vm.lookupOnKeyPress = function (event) {
                if (event.keyCode === 13 && !vm.enterManually) {
                    event.preventDefault();
                    vm.lookupAddress();
                }
            };

            // Step 2: resolve the selected suggestion to a full address
            vm.suggestionOnChange = function () {
                if (vm.selectedSuggestion) {
                    vm.resolveInProgress = true;
                    updateProcessing();
                    gbGroupService.resolveAddress(vm.selectedSuggestion.id).then(function (address) {
                        clearAddress();
                        for (var prop in address) {
                            vm.address[prop] = address[prop];
                        }
                    }, function () {
                        vm.lookupError = 'gbGroup.error.unexpected';
                    })['finally'](function () {
                        vm.resolveInProgress = false;
                        updateProcessing();
                    });
                }
            };

            // also clears the suggestions and lookup error
            vm.postcodeOnChange = function () {
                if (vm.postcode !== vm.lookeduppostcode) {
                    clearAddress();
                    vm.lookupError = null;
                    vm.suggestions = null;
                    vm.selectedSuggestion = null;
                }
                vm.address.postcode = vm.postcode;
            };

            // remove lookup errors when switching to manual entry
            vm.toggleEnterManually = function () {
                var toggleAction = vm.enterManually ? 'cancel' : 'show';
                ppTrack.action('address-kyc-uk.enter-manually.' + toggleAction);

                vm.lookupError = null;
                vm.enterManually = !vm.enterManually;

                if (vm.enterManually) {
                    vm.address = vm.address || {};
                    vm.address.postcode = vm.postcode;
                }

                vm.selectedSuggestion = null;
            };

            // -- scope bindings

            // In this instance vm.feedbackEnabled is a proxy for form.$submitted
            $scope.$watch('vm.feedbackEnabled', function (enabled) {
                if (enabled && vm.form.$invalid) {
                    vm.enterManually = true;
                }
            });

            // -- main

            vm.$postLink = function () {
                ppComponentEmitter.emit('address-kyc-uk.dom.loaded', $element);
            };

            vm.$onInit = function () {
                ppComponentEmitter.emit('address-kyc-uk.controller.loaded', vm);
            };
        }]
    };
}]);
})(window, window.angular);